// extracted by mini-css-extract-plugin
module.exports = {"container":"page-wrapper_container__Ysl2R","fullScreen":"page-wrapper_fullScreen__V3_8W"};